









































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { HomeApi } from "@/api/homeApi";
import { CommonApi } from "@/api/commonApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class Index extends Vue {
  banners: Array<object> = [];
  imgTextList1: Array<object> = [];
  imgTextList2: Array<object> = [];
  imgTextList3: Array<object> = [];
  videoList1: Array<object> = [];
  videoList2: Array<object> = [];
  videoList3: Array<object> = [];
  optionList: Array<object> = [];
  homeApi = new HomeApi();
  videoTabIdx = 0;
  videoTabs: Array<string> = ["究酒99", "名庄风采", "高手在民间"];
  videoTypes: Array<number> = [7, 8, 9];
  videoParentId = 7;
  textImgTabIdx = 0;
  textImgTabs: Array<string> = ["究酒99", "名庄风采", "高手在民间"];
  textImgTypes: Array<number> = [10, 11, 12];
  textImgParentId = 10;

  mounted() {
    this.homeApi.getBanners().then((res) => {
      this.banners = res.data;
    });

    this.homeApi.getOptions().then((res) => {
      this.optionList = res.data;
    });

    this.homeApi.getVideos().then((res) => {
      this.videoList1 = res.data.videoList1;
      this.videoList2 = res.data.videoList2;
      this.videoList3 = res.data.videoList3;
    });

    this.homeApi.getImgTexts().then((res) => {
      this.imgTextList1 = res.data.imgTextList1;
      this.imgTextList2 = res.data.imgTextList2;
      this.imgTextList3 = res.data.imgTextList3;
    });
  }

  /**
   *   切换视频Tab
   */
  changeVideoTab(tabIndex: number) {
    this.videoTabIdx = tabIndex;
    this.videoParentId = this.videoTypes[tabIndex];
  }

  /**
   *   切换图文Tab
   */
  changeTextImgTab(tabIndex: number) {
    this.textImgTabIdx = tabIndex;
    this.textImgParentId = this.textImgTypes[tabIndex];
  }
}
